<template>
  <div class="esport-comp-container">
    <div class="title">
      <div class="back-btn" @click="back"></div>
      <div class="text">
        <AutoTitle :runTimeSecondLenght="10" :textData="title">
          <span>{{ title }}</span>
        </AutoTitle>
      </div>
    </div>
    <div class="detail-box">
      <template v-for="(partData, index) of partList">
        <img
          class="image"
          :key="index"
          v-if="partData.valueType == 'image'"
          :src="partData.value"
        />
        <preDiv
          :key="index"
          v-if="partData.valueType == 'text'"
          class="introduce-desc"
          :text="partData.value"
        />
      </template>
    </div>
    <div class="bottom-splint-box"></div>
  </div>
</template>

<script>
import { getDict, invokeNative, axios, bus } from "@/common";
import { mapState, mapGetters } from "vuex";
import store from "@/store";
import AutoTitle from "@/components/autoTitle";
import preDiv from "@/components/preDiv";

export default {
  name: "eSportNews",
  // mixins: [getPageLevelMixin],
  components: {
    AutoTitle,
    preDiv,
  },
  props: {
    newsId: {},
  },
  data() {
    return {
      title: "",
      partList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    getDict,
    back() {
      this.$emit("back");
    },
    async getData() {
      let result = await axios.get(`/api/eSport/news/${this.newsId}`);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          if (data.detail) {
            this.title = data.detail.title;
            this.partList = data.detail.partList;
          }
        }
      }

      // linkClubId;
    },
  },
  mounted() {},
  created() {
    this.getData();
  },
};
</script>

  <style lang="scss" scoped>
/* 定义$page-nav-height */
@import "../../comps/nav/index.scss";
.esport-comp-container {
  height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  $title-height: 0.7rem;
  $padding: 0.2rem;

  .title {
    width: 100%;
    height: $title-height;
    line-height: $title-height;
    font-size: 0.24rem;
    font-weight: 600;
    padding: 0 $padding;
    display: flex;
    align-items: center;
    // background: url(./imgs/nav-item.png);
    // background-image: url(../../imgs/tab-nav.png);
    background-image: url(../../imgs/tab-switch-btn-bg.png);
    background-size: 100% 100%;

    .back-btn {
      width: 0.37rem;
      height: 0.31rem;
      background-image: url(./imgs/back-btn.png);
      background-size: 100% 100%;
    }

    .text {
      margin-left: 0.15rem;
      width: 0;
      flex: 1;
      span {
        background-image: -webkit-linear-gradient(bottom, #f39b25, #a76002);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .detail-box {
    flex: 1;
    background-color: rgba(#fff, 0.3);
    overflow-y: auto;
    color: #454545;
    font-size: 0.2rem;
    line-height: 0.34rem;
    padding: $padding;

    .image {
      max-width: 100%;
    }
  }
}
.bottom-splint-box {
  $margin-bottom: 0.08rem;
  width: 100%;
  height: $margin-bottom;
  display: flex;
  align-items: flex-end;
  &::before {
    content: "";
    flex: 1;
    height: 0.04rem;
    border-bottom: 0.01rem solid rgba(#fff, 0.4);
    margin-right: 0.04rem;
  }
  &::after {
    content: "";
    width: 0.34rem;
    height: 0.04rem;
    background-image: url(../../imgs/box-bottom-splint.png);
    background-size: 100% 100%;
  }
}
</style>
